import React from "react";
import { styled } from "styled-components";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import InlineSvg from "react-inlinesvg";

import { imgList } from "@constants/imgs";

type Props = { visible: boolean; onOk: () => void; onCancel: () => void };

const ModalSuccess = ({ visible, onOk, onCancel }: Props) => {
  const { t } = useTranslation();

  return (
    <Contents id="modal-success">
      <Modal
        title={""}
        width={400}
        open={visible}
        closable={false}
        onOk={onOk}
        onCancel={onCancel}
        getContainer={() =>
          document.getElementById("modal-success") as HTMLElement
        }
        footer={false}
      >
        <InlineSvg src={imgList.confirm} />
        <div className="modal-success__title">{t(`Login:title.complete`)}</div>
        <div className="modal-success__description">
          {t(`Login:description.complete`)}
        </div>
      </Modal>
    </Contents>
  );
};

export default ModalSuccess;

const Contents = styled.div`
  .ant-modal-body {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column;
  }
  .ant-modal-content {
    padding: 50px;
  }
  .modal-success {
    &__title {
      font-size: 30px;
      font-style: normal;
      font-weight: 500;
      line-height: 32px;
      margin: 0 0 20px;
    }
    &__description {
      color: #667085;
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
    }
  }
`;
